import React, { forwardRef, useRef } from "react";
import makeStyles from "@mui/styles/makeStyles";
//import jsPDF from "jspdf";

//Services

import swal from "sweetalert";

//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";



import { useTranslation } from "react-i18next";

import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { fr, enGB } from "date-fns/locale"; // import French and English locale

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { getFacilityListByGroup } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

import { format, subDays } from "date-fns";
const OrderInv = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage"),
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "order";
  const FacilityId = localStorage.getItem("FacilityId");
  const FacilityName = localStorage.getItem("FacilityName");
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;
  const userId = UserInfo == 0 ? "" : UserInfo[0].id;

  const DefaultFacilityId = localStorage.getItem("DefaultFacilityId");
  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const assignedProdGroupList = UserInfo[0].ItemGroupId.split(",");
  const [prodGroupCountUnderRole, setProdGroupCountUnderRole] = React.useState(
    assignedProdGroupList.length,
  );

  //const RoleItemGroupId = UserInfo==0?'': UserInfo[0].ItemGroupId;
  const RoleItemGroupId = UserInfo == 0 ? "" : assignedProdGroupList[0];

  const ProductGroupList = JSON.parse(localStorage.getItem("ProductGroupList"));
  const [currProductGroupId, setCurrProductGroupId] = useState(RoleItemGroupId);

  const [FacilityList, setFacilityList] = useState(
    getFacilityListByGroup(RoleItemGroupId),
  );
  const isFacilityIdFound = FacilityList.some(
    (facility) => facility.id == FacilityId,
  );
  const [currFacilityId, setCurrFacilityId] = useState(
    isFacilityIdFound ? FacilityId : "",
  );

  const handleProductGroupChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrProductGroupId(rowId);

    const newFacilityList = getFacilityListByGroup(rowId);
    setFacilityList(newFacilityList);

    const isFacilityIdFound = newFacilityList.some(
      (facility) => facility.id == DefaultFacilityId,
    );
    setCurrFacilityId(isFacilityIdFound ? DefaultFacilityId : "");
  };

  const handleFacilityChange = (event, newValue) => {
    let rowId = "";
    if (newValue == null) {
      rowId = "";
    } else {
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
    let params2 = {
      action: "gUserListByFacility",
      menukey: menukey,
      FacilityId: rowId,
    };
    mutategUserListByFacility(params2);
  };

  const { mutate: mutategUserListByFacility } = useMutation(
    api.gUserListByFacility,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          localStorage.setItem(
            "UsersListByFacility",
            JSON.stringify(data.data.datalist),
          );
        }
      },
    },
  );

  React.useEffect(() => {
    localStorage.setItem("FacilityId", currFacilityId);
  }, [currFacilityId]);

  const StatusList = [
    {
      id: 1,
      name: t(DispensingLanguage[lan][menukey]["Draft"]),
      ColorCode: "#ff0000",
    },
    {
      id: 2,
      name: t(DispensingLanguage[lan][menukey]["Complete"]),
      ColorCode: "#ffa500",
    },
    {
      id: 3,
      name: t(DispensingLanguage[lan][menukey]["Approve"]),
      ColorCode: "#008000",
    },
    {
      id: 4,
      name: t(DispensingLanguage[lan][menukey]["Receive"]),
      ColorCode: "#0000ff",
    },
  ];

  const [dataItems, setDataItems] = useState([]);

  const [selectedStartDate, setSelectedStartDate] = React.useState(
    format(subDays(new Date(), 90), "yyyy-MM-dd"),
  );

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
    setLoading(true);
  };

  const [selectedEndDate, setSelectedEndDate] = React.useState(
    format(new Date(), "yyyy-MM-dd"),
  );

  const handleEndDateChange = (date) => {
    setSelectedEndDate(date);
    setLoading(true);
  };

  const queryClient = useQueryClient();

  const [isLoading, setLoading] = useState(true);

  let params = {
    menukey: menukey,
    FacilityId: currFacilityId,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
    StartDate: selectedStartDate,
    EndDate: selectedEndDate,
    ItemGroupId: currProductGroupId,
  };
  const { error, isError, data, refetch } = useQuery(
    [params],
    api.getOrderInvs,
    {
      onSuccess: (data) => {
        setDataItems(data);
        setLoading(false);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    },
  );

  const { mutate } = useMutation(api.deleteOrderInv, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        refetch();
        queryClient.getQueriesData("order");

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
          duration: 10000,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let StartDate = format(new Date(selectedStartDate), "yyyy-MM-dd");
    let EndDate = format(new Date(selectedEndDate), "yyyy-MM-dd");
    let currFacilityName = (
      FacilityList.find(
        (Facility_List) => Facility_List.id == currFacilityId,
      ) ?? null
    ).name;

    window.open(
      finalUrl +
        "?action=getExportOrdersBook" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&FacilityId=" +
        currFacilityId +
        "&FacilityName=" +
        currFacilityName +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate +
        "&ItemGroupId=" +
        currProductGroupId +
        "&TimeStamp=" +
        Date.now(),
    );
  };
  /* =====End of Excel Export Code==== */

  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editOrderInvs(rowData);
  };

  var StatusIcon = function (cell, formatterParams) {
    //plain text value
    const CellValueForOrder = cell._cell.row.data;

    //bReceived
    //console.log("bbbbb",CellValueForOrder);
    //console.log("sssss",CellValueForOrder.bCompleted);

    if (CellValueForOrder.bReceived == 1) {
      return "<i class='fa fa-check' style='color:blue'></i>";
    } else {
      if (CellValueForOrder.bCompleted == 1) {
        return "<i class='fa fa-check' style='color:green'></i>";
      } else if (CellValueForOrder.bCompleted == 0) {
        return "<i class='fa fa-check' style='color:orange'></i>";
      } else if (CellValueForOrder.bCompleted == -1) {
        return "<i class='fa fa-times' style='color:red'></i>";
      }
    }
  };

  const columns = [
    { title: "Id", field: "id", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 80,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order Date"]),
      width: 130,
      field: "OrderDate",
      headerFilter: true,
      formatter: function (cell, formatterParams) {
        let value = cell.getValue();
        return format(new Date(value), "dd/MM/yyyy");
      },
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order No"]),
      field: "OrderNo",
      width: 240,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Order To"]),
      field: "OrderTo",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Entry By"]),
      field: "EntryBy",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Status"]),
      field: "bCompleted",
      hozAlign: "center",
      width: 100,
      //formatter: "tickCross",
      formatter: StatusIcon,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerHozAlign: "center",
      headerSort: false,
      hozAlign: "center",
      width: 100,
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editOrderInvs = (data) => {
    let route = `order/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteOrderInvs = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this order!"
        ],
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        mutate(data.id);
      }
    });
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (rowData.bCompleted == 1 || rowData.bCompleted == 0 || permissionType)
      return (
        <>
          <ViewList
            onClick={() => {
              editOrderInvs(rowData);
            }}
          />
        </>
      );
    else
      return (
        <>
          <Edit
            onClick={() => {
              editOrderInvs(rowData);
            }}
          />

          <DeleteOutline
            onClick={() => {
              deleteOrderInvs(rowData);
            }}
          />
        </>
      );
  }

  return (
    <>
      <div className={classes.OrderPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {t(DispensingLanguage[lan][menukey]["Order"])}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        {/* start of filter */}
        <Card className="sw_card sw_filter_card">
          <CardContent className="sw_filterCardContent">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={9}>
                <Grid container spacing={2}>
                  <Grid item xs={3} sm={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                      <Grid container justifyContent="space-around">
                        <DatePicker
                          inputFormat="dd/MM/yyyy"
                          label={t(DispensingLanguage[lan][menukey]["From"])}
                          value={selectedStartDate}
                          onChange={handleStartDateChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              className={classes.fullWidth}
                              id="date-picker-inline"
                            />
                          )}
                        />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={3} sm={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                      <Grid container justifyContent="space-around">
                        <DatePicker
                          inputFormat="dd/MM/yyyy"
                          label={t(DispensingLanguage[lan][menukey]["To"])}
                          value={selectedEndDate}
                          onChange={handleEndDateChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              className={classes.fullWidth}
                              id="date-picker-inline"
                            />
                          )}
                        />
                      </Grid>
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={2} sm={2}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="ProductGroupList"
                        disableClearable
                        disabled={prodGroupCountUnderRole > 1 ? false : true}
                        //disabled={userId==1?false:true}
                        options={ProductGroupList}
                        onChange={(event, newValue) =>
                          handleProductGroupChange(event, newValue)
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        value={
                          ProductGroupList.find(
                            (productGroupList) =>
                              productGroupList.id == currProductGroupId,
                          ) ?? null
                        }
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={
                              DispensingLanguage[lan][menukey]["Product Group"]
                            }
                            variant="standard"
                            hiddenLabel
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={4} sm={4}>
                    <FormControl className={classes.fullWidth}>
                      <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="FacilityList"
                        disableClearable
                        disabled={IsAllFacility == 1 ? false : true}
                        options={FacilityList}
                        value={
                          FacilityList.find(
                            (facility) => facility.id == currFacilityId,
                          ) || null
                        }
                        onChange={(event, newValue) =>
                          handleFacilityChange(event, newValue)
                        }
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          value?.id == null || option?.id === value?.id
                        }
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            <Typography className="sw_fontSize">
                              {option.name}
                            </Typography>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={DispensingLanguage[lan][menukey]["Facility"]}
                            variant="standard"
                            hiddenLabel
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={3}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!(permissionType || !currFacilityId)}
                        color="info"
                        className="me-2"
                        onClick={() => {
                          props.history.push(
                            "/order/add/" + currProductGroupId,
                          );
                        }}
                      >
                        {t(DispensingLanguage[lan][menukey]["Add Order"])}
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("print")}
                      >
                        <i className="fas fa-print"></i>
                      </Button>

                      <Button
                        color="info"
                        className="me-2 sw_icons"
                        onClick={() => PrintPDFExcelExportFunction("excel")}
                      >
                        <i className="far fa-file-excel"></i>
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={3}></Grid>
              <Grid item xs={12} sm={6}>
                <div className="mylegend_area OrderApprovalCheck">
                  <span className="float-start marginleft">
                    {DispensingLanguage[lan][menukey]["Status"] + ":  "} &nbsp;
                  </span>

                  {StatusList.map((item, index) => {
                    return (
                      <div key={index} className="my_legend">
                        <div
                          className="mylegend_color"
                          style={{ background: item.ColorCode }}
                        ></div>
                        <div className="mylegend_label"> {item.name}</div>
                      </div>
                    );
                  })}
                </div>
              </Grid>
              <Grid item xs={12} sm={3}></Grid>

              {/* <Grid container item xs={5} sm={5} style={{ paddingTop: 10 }}>
                <Grid  style={{  padding: 5 }}>
                  {DispensingLanguage[lan][menukey]["Status"]+':'}
                </Grid>
                
                  {[t(DispensingLanguage[lan][menukey]["Not Complete"]), t(DispensingLanguage[lan][menukey]["Complete"]),t(DispensingLanguage[lan][menukey]["Approve"]),t(DispensingLanguage[lan][menukey]["Receive"])].map(status => (
                    <Grid 
                        key={status}
                        item xs={12} sm={2}
                        style={{ 
                          backgroundColor: getColor(status),
                          padding: 5,
                          textAlign: "center",
                          color: "white", 
                          width: "100%",
                          height: "75%"
                          
                        }}
                      >
                      {status}
                    </Grid>
                  ))}
              </Grid>


              <Grid item xs={3} sm={3}>

                <div className="float-end sw_btn_control">
                  <Button
                    color="info"
                    className="me-2"
                    onClick={() => {
                      props.history.push("/order/add");
                    }}
                  >
                    {t(DispensingLanguage[lan][menukey]["Add Order"])}
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("print")}
                  >
                    <i className="fas fa-print"></i>
                  </Button>

                  <Button
                    color="info"
                    className="me-2 sw_icons"
                    onClick={() => PrintPDFExcelExportFunction("excel")}
                  >
                    <i className="far fa-file-excel"></i>
                  </Button>
                </div>
              </Grid> */}
            </Grid>
          </CardContent>
        </Card>
        {/* end of filter */}

        <div className="sw_relative">
          {isLoading && <LoadingSpinnerOpaque />}
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              height="450px"
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderInv;

const useStyles = makeStyles({
  OrderPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
